import api from '@synergycms_core/utils/api';
import { List, Map, fromJS } from 'immutable';
import ParamsParser from '@synergycms_core/utils/paramsParser';
//import { is } from 'ramda';
// import actions from '../actions';
import hotelsActions from '@synergycms_core/store/hotels/hotelsActions';
import { mergeAll, contains, filter, forEach,keys } from 'ramda';
import actions from '@synergycms_app/store/actions';

export default {
  ...hotelsActions,
  GET_ASYNC: (hotelIds = []) => {
    return (dispatch, getState) => {
      const store = getState();
      const hotelId = store.getIn(['customer', 'params', 'params', 'hotelId']);
      if(!hotelIds.size) hotelIds = store.getIn(['customer', 'params', 'params', 'hotels'], List());

      if (hotelId && !hotelIds.find(id => id === hotelId)) {
        hotelIds = hotelIds.push(hotelId);
      }
      const generalError = queryHotels => {
        //dispatch(actions.notifications.send('error', '_%error al recuperar la disponibilidad%_'));
        return Promise.resolve(
          queryHotels.reduce((response, hotelId) => response.set(hotelId, Map({ success: false })), Map())
        );
      };
      const hotels = store.get('hotels');
      let queryHotels = List();
      if (hotelIds && hotelIds.size) {
        hotelIds.forEach(id => {
          if (!hotels.getIn([parseInt(id, 10), 'id']) || !hotels.getIn([id, 'id'])) {
            queryHotels = queryHotels.push(id);
          }
        });
        if (queryHotels.size) {
          return api.get({
            path:`descriptives`,
            fullFiled: ()=> {
              const hotels = getState().get("hotels");
              const hotelss = hotelIds.reduce(function(previous, key) { 
                previous[key] = hotels[key];
                return previous;
              }, Map());
              return hotelss.size && hotelss;
            },
            store: ({ store, request }) => {
              const ids = keys(store);
              const requestdHotels = queryHotels.toJS()

              const filteredRequest = filter((key)=>{
                return !contains(key, ids);
              }, requestdHotels);

              const res =[];
              let initRequest;
              if(filteredRequest.length) { 
                initRequest = request({q:"hotels:"+filteredRequest.join(";")});
              }

              forEach((id) => {
                if(contains(id, filteredRequest)) {
                   store[id] = initRequest;
                   res.push(initRequest);
                } else {
                  res[id] = store[id];
                  res.push(initRequest);
                }
              }, requestdHotels);

              return Promise.all(res).then((res) => {
                return mergeAll(res);
              });
            }
          }).then(hotelsData => {
              if (hotelsData.success !== false) {
                
                const newHotelsData = fromJS(hotelsData);
                return newHotelsData.reduce((newObjHotels, hotel, hotelId) => {
                  let mergedHotel;
                  const success = hotel && hotel.size > 0;
                  if (success) {
                    const hotelInfo = store
                      .getIn(['hotels', 'hotels_info', 'hotels'])
                      .find(h => h.get('id') === hotelId);
                    mergedHotel = hotelInfo && hotelInfo.merge(hotel);
                  } else {
                    mergedHotel = hotel;
                  }
                  return mergedHotel ? newObjHotels.set(hotelId, mergedHotel.set('success', success)) : newObjHotels;
                }, Map());
              } else {
                return generalError(queryHotels);
              }
            })
            .catch(err => {
              return generalError(queryHotels);
            });
        }
      }
      return Promise.resolve();
    };
  },
  SET_LAST_QUERY_PARAMS: (hotelId, managerParams, newParams) => (dispatch, getState) => {
    if (!hotelId) {
      hotelId = getState().getIn(['customer', 'current_hotel'], null);
    }

    const prefix = managerParams.getPrefix();
    //const oldParams = getState().getIn(['hotels', hotelId, 'params', prefix.stringQuery], OrderedMap());
    const queryParams = managerParams.toObj();
    const stringQueryParams = managerParams.toString();
  

    const calendarQueryParams = managerParams.toObjType("calendar", Map({'checkin_days': 30, 'refundability': 'any', skip_restrictions : true}));
    const stringCalendarQueryParams = managerParams.toStringType("calendar", calendarQueryParams);

    const baseCalendarQueryParams =  managerParams.toObjType("calendar", Map({'checkin_days': 30, 'refundability': 'any', skip_restrictions : true}), true);
    const baseStringCalendarQueryParams = managerParams.toStringType("calendar", baseCalendarQueryParams);


    const serviceQueryParams = Map({
      date: queryParams.get('date'),
      stay_length: queryParams.get('stay_length'),
      daily_details: true
    });

    const stringServiceQueryParams = ParamsParser.paramsToQuery(serviceQueryParams);

    
    return Map()
      .set("hotelId",hotelId)
      .set(prefix.params, queryParams)
      .set(prefix.stringParams, stringQueryParams)
      .set(prefix.paramsCalendar, calendarQueryParams)
      .set(prefix.stringCalendar, stringCalendarQueryParams)
      .set(prefix.baseParamsCalendar, baseCalendarQueryParams)
      .set(prefix.baseStringCalendar, baseStringCalendarQueryParams)
      .set(prefix.paramsService, serviceQueryParams)
      .set(prefix.stringService, stringServiceQueryParams)
      .set(prefix.base,  managerParams.stringBaseParams);
  },
  SEND_CONFIRMATION_GUEST: (hotelId) => (dispatch, getState) => {
    const store = getState();
    const reservation = store.getIn(['customer', 'reservation']);
    const trackingId = reservation.get('tracking_id');
    const pinCode = reservation.get('pin_code');
    
    const extraHeaders = [{ Authorization: 'Basic ' + btoa(trackingId + ':' + pinCode) }];
    return api.get(`cms/send_confirmation_guest/${trackingId}`, {}, hotelId, extraHeaders).then(response => {
      return response
    });
  },
  SET_RELATED_HOTELS: () => {
    return (dispatch, getState) => {
      const store = getState();
      const params = store.getIn(['customer', 'params', 'params'], undefined);
      const webType = store.getIn(['customer', 'web_type'], false);
      const city =
        webType !== 'WI' &&
        params &&
        params.get('city_id') &&
        store.getIn(['hotels', 'hotels_info', 'cities']).find(city => {
          return city.get('id') === parseInt(params.get('city_id'), 10);
        });
      let cityId = city.get('id');
      var hotelIds = store.getIn(['hotels'])
        .getIn(['hotels_info', 'hotels'])
        .filter(h => h.get('city_id') === cityId)
        .toJS()
        .reduce((hotelsCity, hotel) => hotelsCity.concat([hotel.id]), List());

      Promise.all([
        dispatch(actions.hotels.getAsync(hotelIds))
      ]).then(() => true);
    }
  },
};
